import { favoriteListQueryKeys as e } from "./favoriteListQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { favoriteListsApi as r } from "@maat/api-main";
//#region src/favoriteLists/useUpdateFavoriteListMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ listId: e, name: t }) => r.updateList(e, t),
		onSuccess: (t, { listId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.feed() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useUpdateFavoriteListMutation };
